import { render } from "./BaseCompareTable.vue?vue&type=template&id=619b57e7"
import script from "./BaseCompareTable.vue?vue&type=script&lang=js"
export * from "./BaseCompareTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__